<template lang="pug">
  price-board(v-model="createPriceComponentData")
</template>

<script>
import PriceBoard from "@/components/PriceBoard";

export default {
  name: "ContractChatPrice",
  components: {
    PriceBoard
  },
  props: {
    value: {type: Object, required: false},
  },
  computed: {
    // 金額表示のコンポーネント用データ作成
    createPriceComponentData() {
      // 金額表示のコンポーネント用データ初期化
      let forPriceData = {}

      // プラン名
      forPriceData.plan_name = 'chatluck'

      // ChatLuckユーザー数
      if (this.value.chat_user !== null) {
        // ユーザ数
        forPriceData.plan_user = this.value.chat_user
      }

      // オプションサービス
      if (this.value.option === true) {
        // チェックボックス
        forPriceData.chat_option_service = this.value.option

        // ディスク増設
        if (this.value.disk === true) {
          forPriceData.chat_option_disk      = this.value.disk      // チェックボックス
          forPriceData.chat_option_disk_size = this.value.disk_size // 増設容量
        }
      }

      // お見積番号
      forPriceData.estimate = this.value.estimate

      // 金額表示のコンポーネント用データを返す
      return forPriceData;
    }
  }
}
</script>

<style scoped>

</style>